import { useAutoScroll } from '@/hooks/useAutoScroll';
import { useState } from 'react';

export const ScrollableText = ({
  text,
  className = '',
}: {
  text: string;
  className?: string;
}) => {
  const { elementRef, startAutoScroll, stopAndReset } = useAutoScroll();
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
    startAutoScroll();
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    stopAndReset();
  };

  return (
    <span
      ref={elementRef}
      className={`sidebar-label-container ${className}`}
      style={{
        maxWidth: '140px',
        minWidth: '0',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: isHovered ? 'clip' : 'ellipsis',
        display: 'block',
        verticalAlign: 'middle',
        cursor: 'pointer',
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {text}
    </span>
  );
};
